<template>
  <div class="ui basic container segment">
    <div class="ui left close rail">
      <!-- <last-sales /> -->
    </div>
    <div class="ui container grid">
      <div class="ten wide column" style="padding-left: 0; padding-top: 0">
        <point-of-sale-product @add_to_cart="add_to_cart" />
      </div>
      <div class="six wide column" style="padding-right: 0; padding-top: 0">
        <point-of-sale-cart
          ref="point_of_sale_cart"
          @order_saved="order_saved"
          @payment_succedded="payment_succedded"
        />
        <point-of-sale-customer @select_customer="select_customer" />
      </div>
    </div>
    <component
      :is="submodule.setup.plugin.component"
      :module="submodule"
      v-for="(submodule, index) in submodules"
      v-bind:key="index"
      @session_updated="session_updated"
      ref="submodule"
    ></component>
    <point-of-sale-account
      ref="point_of_sale_acount"
      @select_account="select_account"
    />
  </div>
</template>

<script>
import { load_submodules } from "@/utils";
import filters from "@/filters";
import PointOfSaleCustomer from "./PointOfSaleCustomer";
import PointOfSaleProduct from "@/modules/point_of_sale/product/PointOfSaleProduct";
import PointOfSaleCart from "@/modules/point_of_sale/cart/PointOfSaleCart";
import PointOfSaleAccount from "./PointOfSaleAccount";
import PointOfSaleSessionPlugin from "@/modules/point_of_sale/session/PointOfSaleSessionPlugin";
// import LastSales from "./PointOfSaleLastSales";

// @ is an alias to /src
export default {
  name: "PointOfSaleIndex",
  components: {
    PointOfSaleCustomer,
    PointOfSaleProduct,
    PointOfSaleCart,
    PointOfSaleAccount,
    PointOfSaleSessionPlugin,
    // "last-sales": LastSales
  },
  filters: filters,
  data() {
    return {
      submodules: [],
    };
  },
  methods: {
    add_to_cart(product) {
      this.$refs.point_of_sale_cart.add_to_cart(product);
    },
    order_saved(order) {
      this.$refs.point_of_sale_acount.add_order(order);
    },
    select_account(account) {
      this.$refs.point_of_sale_cart.load_account(account);
    },
    select_customer(customer) {
      this.$refs.point_of_sale_cart.select_customer(customer);
    },
    session_updated(session) {
      this.$refs.point_of_sale_cart.set_session(session);
    },
    payment_succedded() {
      this.$refs.submodule.map((m) => {
        if (
          m.$attrs &&
          m.$attrs.module &&
          m.$attrs.module.setup &&
          m.$attrs.module.setup.name == "point of sale session"
        )
          m.refresh();
      });
    },
  },
  mounted() {
    let vm = this;

    load_submodules(vm, "point of sale");
  },
  watch: {},
};
</script>
